import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const Wrapper = styled.div`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
  }
  .ant-checkbox-inner {
    border-color: ${Colors.primary} !important;
  }
  .ant-checkbox ant-checkbox-checked {
    border-color: ${Colors.primary} !important;
  }
`;

export default {
  Wrapper,
};
